import { createJSONStorage, persist } from "zustand/middleware";
import { UserData, UserRoles } from "./interface";
import { PERSIST_SECRET_KEY } from "../../constants/common";
import { createZustandStore } from "../../utils/resetStore";

const initialState = {
  isLoggedIn: false,
  token: "",
  user: {} as UserData,
  userRoles: {},
};

export interface AuthState {
  isLoggedIn?: boolean;
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  user?: UserData | null;
  setUserData: (user: UserData | null) => void;
  token?: string;
  setToken: (token: string) => void;
  userRoles: UserRoles;
  setUserRoles: (roles: UserRoles) => void;
  reset: () => void;
}

const useAuthStore = createZustandStore<AuthState>()(
  persist(
    (set) => ({
      isLoggedIn: initialState.isLoggedIn,

      setIsLoggedIn: (isLoggedIn: boolean): void => {
        set({ isLoggedIn });
      },

      token: initialState.token,

      setToken: (token: string): void => {
        set({ token });
      },

      setUserData: (user: UserData | null): void => {
        set({ user });
      },

      userRoles: initialState.userRoles,

      setUserRoles: (roles) => set({ userRoles: roles }),

      reset: () => {
        set(initialState);
      },
    }),
    {
      name: PERSIST_SECRET_KEY,
      storage: createJSONStorage(() => window.localStorage),
    }
  )
);

export default useAuthStore;
